import { defineMessages } from 'react-intl';

export const visualDxAgentToolMessages = defineMessages({
  diagnosticFlowStatus: {
    id: '6HJhvlWJfi',
    defaultMessage: 'VisualDx diagnostic flow',
    description: 'Status label while an Evidence VisualDx diagnostic flow is loading',
  },
  rankedDifferentialStatus: {
    id: '2u7vaEjqZL',
    defaultMessage: 'VisualDx ranked differential',
    description: 'Status label while an Evidence VisualDx differential is loading',
  },
  galleryStatus: {
    id: 'SezUrqFO0q',
    defaultMessage: 'VisualDx image gallery',
    description: 'Status label while an Evidence VisualDx gallery tool is loading',
  },
  compareStatus: {
    id: 'hjqJLn7Hih',
    defaultMessage: 'VisualDx diagnosis compare',
    description: 'Status label while an Evidence VisualDx compare tool is loading',
  },
  drugReactionStatus: {
    id: 'JChTmpMkH0',
    defaultMessage: 'VisualDx drug-reaction differential',
    description: 'Status label while an Evidence VisualDx drug-reaction tool is loading',
  },
});
